import { lazy } from 'react';

const PoliciesAndTerms = lazy(() => import('./PoliciesAndTerms'));
const AccountManagement = lazy(() => import('./AccountManagement'));

export { PoliciesAndTerms, AccountManagement };

